/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_New_PasswordInputs */

const en_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm New Password`)
};

const es_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar nueva contraseña`)
};

const fr_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer le nouveau mot de passe`)
};

const de_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Passwort bestätigen`)
};

const ja_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいパスワード (確認)`)
};

const zh_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认新密码`)
};

const ar_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأكيد كلمة المرور الجديدة`)
};

const id_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi Kata Sandi Baru`)
};

const it_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma Nuova Password`)
};

const ru_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердите новый пароль`)
};

const pt_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar Nova Senha`)
};

const ko_confirm_new_password = /** @type {(inputs: Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 비밀번호 확인`)
};

/**
* | output |
* | --- |
* | "Confirm New Password" |
*
* @param {Confirm_New_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const confirm_new_password = /** @type {((inputs?: Confirm_New_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_New_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_new_password(inputs)
	if (locale === "es") return es_confirm_new_password(inputs)
	if (locale === "fr") return fr_confirm_new_password(inputs)
	if (locale === "de") return de_confirm_new_password(inputs)
	if (locale === "ja") return ja_confirm_new_password(inputs)
	if (locale === "zh") return zh_confirm_new_password(inputs)
	if (locale === "ar") return ar_confirm_new_password(inputs)
	if (locale === "id") return id_confirm_new_password(inputs)
	if (locale === "it") return it_confirm_new_password(inputs)
	if (locale === "ru") return ru_confirm_new_password(inputs)
	if (locale === "pt") return pt_confirm_new_password(inputs)
	return ko_confirm_new_password(inputs)
});